import { AxiosError } from 'axios';
import { Dimensions } from 'react-native';
import Toast from 'react-native-root-toast';
import { font } from '@/constant/font';
const ToastUtils = {
    show(message, options) {
        const screenWidth = Dimensions.get('window').width;
        return Toast.show(message, Object.assign({ duration: 2500, position: -55, shadow: false, animation: true, opacity: 1, delay: 0, keyboardAvoiding: true, containerStyle: {
                width: Math.min(350, screenWidth - 40),
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                borderRadius: 8,
                paddingHorizontal: 20,
                paddingVertical: 14,
                justifyContent: 'center',
                alignItems: 'center',
            }, textStyle: {
                fontFamily: font.pretendardRegular,
                fontSize: 15,
                color: '#FFFFFF',
                textAlign: 'center',
                lineHeight: 22,
                letterSpacing: -0.3,
            } }, options));
    },
    showOnApiError(error) {
        var _a, _b, _c, _d;
        let message;
        if (typeof error === 'string') {
            message = error;
        }
        else if (error instanceof AxiosError &&
            typeof ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.msg) === 'string') {
            message = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.msg;
        }
        else if (error instanceof Error) {
            message = error.message;
        }
        return this.show(message);
    },
};
export default ToastUtils;
